import React, { Component } from "react";
import "./dashboard.css";

import { Auth }  from 'aws-amplify';

class AdminDashboard extends Component {

    state = {
        users: [],
        loading: false,
        error: null,

        activationCode : "" ,

        selectedUsers: [],

        filters: {
            experience: "",
            platform: "",
            country: "",
            style: "",
            market: "",
            status : "",
        }
    };

    componentDidMount() {
        this.fetchUsers();
    }

    // 🔥 LOAD FROM API (API Gateway → DynamoDB)
    fetchUsers = async () => {
        try {



            const payload = {
                status: "pending",
                country: this.state.filters.country,
                experience: this.state.filters.experience,
                platform: this.state.filters.platform,
                style: this.state.filters.style,
                market: this.state.filters.market
            };


           //console.log("📤 SENDING PAYLOAD:", payload);

            this.setState({ loading: true, error: null });

            const { filters } = this.state;

            /*const query = new URLSearchParams({

                    BetaAccessStatus: "pending",
                    experience: filters.experience || "",
                    platform: filters.platform || "",
                    country: filters.country || ""
            });*/



            /*const res = await fetch(
                               "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/get-pending-users?${query}"
            );*/


            const res = await fetch(
                "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/get_users_filter", 
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );

           //console.log("2. URL:", url);

             if (!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }

            const data = await res.json();

             console.log("DATA:", data);

            this.setState({
                users: Array.isArray(data) ? data : [],
                loading: false
            });

        } catch (err) {
            this.setState({
                error: err.message,
                loading: false
            });
        }
    };

    // 🎛 FILTER CHANGE (instant backend refresh)
    /*handleFilterChange = (e) => {
        const { name, value } = e.target;

        this.setState(
            prev => ({
                filters: {
                    ...prev.filters,
                    [name]: value
                }
            }),
            this.fetchUsers
        );
    };*/

  handleFilterChange = (e) => {
    const { name, value } = e.target;

    console.log("Filter changed:", name, value);

    this.setState(
        prev => ({
            filters: {
                ...prev.filters,
                [name]: value
            }
        }),
        () => {
            console.log("Updated filters:", this.state.filters);
            this.fetchUsers();
        }
    );
};


    toggleSelection = (username) => {
    this.setState((prev) => {
        const exists = prev.selectedUsers.includes(username);

        return {
            selectedUsers: exists
                ? prev.selectedUsers.filter(u => u !== username)
                : [...prev.selectedUsers, username]
        };
    });
};

    // ✅ APPROVE USER
    /*approveUser = async (username) => {
        await fetch("/api/approve-user", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username })
        });

        // remove instantly from UI
        this.setState(prev => ({
            users: prev.users.filter(u => u.username !== username)
        }));
    };*/


     // ✅ APPROVE USER
    approveUser = async (username) => {
        try {

            console.log("📤 SENDING PAYLOAD:", username);

            await fetch('https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/approve-user', { 
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ username })
            });

            // remove from UI instantly
            this.setState((prev) => ({
                users: prev.users.filter(u => u.username !== username)
            }));

            //send email for confirmation ______________

        } catch (err) {
            console.error("Approve failed:", err);
        }
    };




     bulkApprove = async () => {
        const { selectedUsers } = this.state;

        await fetch("/api/bulk-approve", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                users: selectedUsers
            })
        });

        // remove from UI
        this.setState(prev => ({
            users: prev.users.filter(
                u => !selectedUsers.includes(u.username)
            ),
            selectedUsers: []
        }));
    };




    downloadEA = async () => {

        try {

            const session =
                await Auth.currentSession();

            const token =
                session.getIdToken().getJwtToken();

            const response =
                await fetch(
                    "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/download-bot",
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            const data =
                await response.json();

                 console.log("data  : " + JSON.stringify(data, null, 2));    

            window.location.href =
                data.downloadUrl;

                this.setState({activationCode : data.activationCode}) ;

                //console.log("this.state.activationCode ......  : " + JSON.stringify(this.state.activationCode, null, 2));    

        } catch (error) {

            console.error(error);
            alert("Download failed.");

        }
    };
    

    render() {
        const { users, loading, error, filters } = this.state;

        return (
            <div className="admin-layout">

                {/* MAIN CONTENT */}
                <div className="admin-main">

                    <div className="pending-users-container">

                        <div className="page-header">
                            <h2 className="page-title">Pending Users</h2>
                            <p className="page-subtitle">
                                Review, approve, or reject new beta applications.
                            </p>
                        </div>

                        {/* FILTERS */}
                        <div className="filter-bar">

                            <select
                                name="experience"
                                value={filters.experience}
                                onChange={this.handleFilterChange}
                            >
                                <option value="">All Experience</option>
                                <option value="Less than 1 year">Less than 1 year</option>
                                <option value="1-3 years">1-3 years</option>
                                <option value="3-5 years">3-5 years</option>
                                <option value="5-10 years">5-10 years</option>
                                <option value="10+ years">10+ years</option>
                            </select>

                            <select
                                name="platform"
                                value={filters.platform}
                                onChange={this.handleFilterChange}
                            >
                                <option value="">All Platforms</option>
                                <option value="MT4">MT4</option>
                                <option value="MT5">MT5</option>
                                <option value="M$-M5">M4-M5</option>
                                <option value="IBKR">IBKR</option>
                                <option value="Ndax">Ndax</option>
                            </select>

                            <select
                                name="country"
                                value={filters.country}
                                onChange={this.handleFilterChange}
                            >
                                <option value="">All Countries</option>
                                <option value="Canada">Canada</option>
                                <option value="USA">USA</option>
                                 <option value="USA">Morocco</option>
                            </select>

                             <select
                                name="style"
                                value={filters.style}
                                onChange={this.handleFilterChange}
                            >
                                <option value="">All Styles</option>
                                <option value="FA">FA</option>
                                <option value="manual">Manual</option>
                                 <option value="SA">SA</option>
                            </select>



                        </div>

                        {/* LOADING */}
                        {loading && <div className="msg">Loading users...</div>}

                        {/* ERROR */}
                        {error && <div className="error">{error}</div>}

                        {/* TABLE */}
                        {!loading && users.length > 0 && (
                            <table className="admin-table">

                                <thead>
                                    <tr>
                                        <th>Select</th>
                                        <th>User</th>
                                        <th>Email</th>
                                        <th>Country</th>
                                        <th>Experience</th>
                                        <th>Platform</th>
                                        <th>Style</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                    <tbody>
                                    {users.map(user => (
                                        <tr key={user.username}>

                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.selectedUsers.includes(user.username)}
                                                    onChange={() => this.toggleSelection(user.username)}
                                                />
                                            </td>

                                            <td>{user.username}</td>
                                            <td>{user.email}</td>
                                            <td>{user.country}</td>
                                            <td>{user.experience}</td>
                                            <td>{user.platform}</td>
                                            <td>{user.style}</td>
                                            <td>{user.status}</td>

                                            <td>
                                                <button
                                                    className="approve-btn"
                                                    onClick={() => this.approveUser(user.username)}
                                                >
                                                    Approve
                                                </button>
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>

                            </table>
                        )}

                    </div>



                    {/*<div className="download-panel">

                        <h3>
                            MT5 Expert Advisor
                        </h3>

                        <p>
                            Download the latest iDMS MT5 Expert Advisor
                            and connect it to your cloud account.
                        </p>

                        <ul>
                            <li>Version: 1.0.3</li>
                            <li>Updated: July 2026</li>
                            <li>Compatible: MT5</li>
                        </ul>

                        <button
                            onClick={this.downloadEA}
                            className="btn btn-primary"
                        >
                            Download EA
                        </button>

                          <br></br>
                           <br></br>

                           <button
                            className=" btn-secondary"
                        >
                            Activation code :
                        </button>&nbsp; &nbsp;<a> {this.state.activationCode}  </a>

                          <br></br>
                           <br></br>

                       <spam> "Please add https://idms-invest.com to MetaTrader → Tools → Options → Expert Advisors → Allow WebRequest."</spam>

                    </div>*/}




                </div>

            </div>
        );
    }
}

export default AdminDashboard;